var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotionsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon promotions black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-promotions-black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5,15.8878719 L43,15.8878719 L43,38.2734554 C43,40.1848398 41.4425,41.7173913 39.5,41.7173913 L11.5,41.7173913 C9.5575,41.7173913 8,40.1848398 8,38.2734554 L8,15.8878719 L18.5,15.8878719 L18.5,12.4439359 C18.5,10.5325515 20.0575,9 22,9 L29,9 C30.9425,9 32.5,10.5325515 32.5,12.4439359 L32.5,15.8878719 Z M22,12.4439359 L22,15.8878719 L29,15.8878719 L29,12.4439359 L22,12.4439359 Z M25.5,31.868135 L29.2617391,34.1086957 L28.2634783,29.8858696 L31.5869565,27.0446224 L27.2104348,26.6782037 L25.5,22.6956522 L23.7895652,26.6782037 L19.4130435,27.0446224 L22.7365217,29.8858696 L21.7382609,34.1086957 L25.5,31.868135 Z",
    id: "Combined-Shape-Copy",
    fill: "#505050",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionsGrey);
export default __webpack_public_path__ + "static/media/promotions-grey.209404509905832d7f635f28b2d1c574.svg";
export { ForwardRef as ReactComponent };